import { render } from "./FormProperties.vue?vue&type=template&id=dfca97d4"
import script from "./FormProperties.vue?vue&type=script&lang=js"
export * from "./FormProperties.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__